import { FC } from 'react';
import { Box, BoxProps, Flex } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import locales from './locales';

interface ReferralOfferProps extends BoxProps {
  referrer: string;
  isAlreadyApplied?: boolean;
}

const ReferralOffer: FC<ReferralOfferProps> = ({
  isAlreadyApplied,
  referrer,
  ...props
}) => (
  <Box paddingY="space-8" {...props}>
    <Flex
      alignItems="center"
      background="blue.300"
      borderRadius="radius-8"
      padding="space-16"
    >
      <Box marginRight={{ base: 'space-8', md: 'space-4' }}>🎉</Box>
      <Text
        fontWeight="weight-500"
        size="sm"
        sx={{
          strong: {
            color: 'text-primary',
            fontWeight: 'weight-500',
          },
        }}
      >
        {locales.formatString(
          isAlreadyApplied
            ? locales.referralOfferApplied
            : locales.referalOffer,
          referrer,
        )}
      </Text>
    </Flex>
  </Box>
);

export default ReferralOffer;
